"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainContentView = MainContentView;
const React = __importStar(require("react"));
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const AdvancedProductSearch = __importStar(require("../../tools/advanced-product-search"));
const AirMixingTool = __importStar(require("../../tools/air-mixing-tool"));
const AirPowerTool = __importStar(require("../../tools/air-power-tool"));
const CoilProTool = __importStar(require("../../tools/coil-pro-tool"));
const Debug = __importStar(require("../../tools/debug"));
const EffectiveClaims = __importStar(require("../../tools/effective-claims/index"));
const FanMotorProTool = __importStar(require("../../tools/fan-motor-pro-tool"));
const FanProTool = __importStar(require("../../tools/fan-pro-tool"));
const HumidityConversionTool = __importStar(require("../../tools/humidity-conversion"));
const MlcUsageStatistics = __importStar(require("../../tools/mlc-usage-statistics"));
const Nevada = __importStar(require("../../tools/nevada"));
const OilonTool = __importStar(require("../../tools/oilon-tool"));
const ProductPricePreview = __importStar(require("../../tools/product-price-preview"));
const PsychometricTool = __importStar(require("../../tools/psychrometric-tool"));
const SystemCompare = __importStar(require("../../tools/system-compare"));
const TAndCAcceptanceStatus = __importStar(require("../../tools/t-and-c-acceptance-status"));
const TranslationSearch = __importStar(require("../../tools/translation-search"));
const UsageStatistics = __importStar(require("../../tools/usage-statistics"));
const ProductPropertySearch = __importStar(require("../../tools/validation/product-property-search"));
const ProductValidation = __importStar(require("../../tools/validation/product-validation"));
const RotorProductValidation = __importStar(require("../../tools/validation/rotor-product-validation"));
const SystemTypePropertySearch = __importStar(require("../../tools/validation/system-type-property-search"));
const SystemTypeValidation = __importStar(require("../../tools/validation/system-type-validation"));
const VariantListing = __importStar(require("../../tools/variant-listing"));
const About = __importStar(require("../about/index"));
const UnsupportedBrowser = __importStar(require("..//unsupported-browser"));
function MainContentView(props) {
    if (!props.selectedTab) {
        return React.createElement("div", null);
    }
    return RenderTab(props.selectedTab);
}
function RenderTab(tab) {
    const subject = tab.subject;
    switch (subject.type) {
        case "AboutTabSubject": {
            return React.createElement(About.Container, null);
        }
        case "AdvancedProductSearchTabSubject": {
            return React.createElement(AdvancedProductSearch.Container, null);
        }
        case "AirMixingToolTabSubject": {
            return React.createElement(AirMixingTool.Container, null);
        }
        case "AirPowerToolTabSubject": {
            return React.createElement(AirPowerTool.Container, null);
        }
        case "CoilProToolTabSubject": {
            return React.createElement(CoilProTool.Container, null);
        }
        case "DebugTabSubject": {
            return React.createElement(Debug.Container, null);
        }
        case "EffectiveClaimsTabSubject": {
            return React.createElement(EffectiveClaims.Container, null);
        }
        case "FanMotorProToolTabSubject": {
            return React.createElement(FanMotorProTool.Container, null);
        }
        case "FanProToolTabSubject": {
            return React.createElement(FanProTool.Container, null);
        }
        case "HumidityConversionTabSubject": {
            return React.createElement(HumidityConversionTool.Container, null);
        }
        case "PsychrometricChartTabSubject": {
            return React.createElement(PsychometricTool.Container, null);
        }
        case "ProductPricePreviewTabSubject": {
            return React.createElement(ProductPricePreview.Component, null);
        }
        case "StartTabSubject":
        case "LabelsManagerSubject":
        case "NewSystemWizardSubject":
        case "PricingEditorSubject":
        case "PricingManagerSubject":
        case "ProjectSelectionTabSubject":
        case "AmountProfileSettingsTabSubject":
        case "CreateNewPricingSubject":
        case "DataCenterWizardSubject":
        case "DefaultSettingsTabSubject":
        case "SystemManagerSubject":
        case "SystemSummary":
        case "PropertiesSelectorExampleSubject":
        case "SystemEditorSubject": {
            return React.createElement("div", null, "no");
        }
        case "UnsupportedBrowserTabSubject": {
            return React.createElement(UnsupportedBrowser.Container, null);
        }
        case "UsageStatisticsTabSubject": {
            return React.createElement(UsageStatistics.Container, null);
        }
        case "NevadaTabSubject": {
            return React.createElement(Nevada.Container, null);
        }
        case "JohanTestSubject": {
            return React.createElement("div", null, "NotImplemented");
        }
        case "SystemTypeValidationTabSubject": {
            return React.createElement(SystemTypeValidation.View, null);
        }
        case "ProductValidationTabSubject": {
            return React.createElement(ProductValidation.View, null);
        }
        case "RotorProductValidationTabSubject": {
            return React.createElement(RotorProductValidation.View, null);
        }
        case "ProductPropertySearchTabSubject": {
            return React.createElement(ProductPropertySearch.View, null);
        }
        case "SystemTypePropertySearchTabSubject": {
            return React.createElement(SystemTypePropertySearch.View, null);
        }
        case "VariantListingTabSubject": {
            return React.createElement(VariantListing.View, null);
        }
        case "SystemCompareTabSubject": {
            return React.createElement(SystemCompare.Container, null);
        }
        case "MlcUsageStatisticsTabSubject": {
            return React.createElement(MlcUsageStatistics.Container, null);
        }
        case "TAndCAcceptanceStatusTabSubject": {
            return React.createElement(TAndCAcceptanceStatus.Container, null);
        }
        case "TranslationSearchTabSubject": {
            return React.createElement(TranslationSearch.Container, null);
        }
        case "OilonToolTabSubject": {
            return React.createElement(OilonTool.Container, null);
        }
        default: {
            (0, ts_exhaustive_check_1.exhaustiveCheck)(subject);
        }
    }
}
//# sourceMappingURL=main-content-view.js.map